export const ACTION_CODE = 'DASHBOARD_OFFICE_MANAGER' + '_SERVICE';
